import { Box, Button, Popover, Theme } from '@material-ui/core';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';
import { gpmVideo } from '../../../videos';
import { createStyles, makeStyles } from '@material-ui/styles';
import { PlayBtn } from '../../../svgs/gpm';
import { monitor } from '../../../images/gpm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    videoContainer: {
      position: 'relative',
      width: '100%',
      paddingTop: '56.25%', // 16:9 aspect ratio
      backgroundImage: `url("${monitor}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    buttonWrapper: {
      position: 'absolute',
      top: '40%',
      left: '49%',
      transform: 'translate(-50%, -50%)',
      zIndex: 2,
    },
    button: {
      background: 'transparent',
      transform: 'scale(0.5)',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      [theme.breakpoints.up('sm')]: {
        transform: 'scale(1)',
      },
    },
    paddingVideo: {
      padding: theme.spacing(2, 2, 0),
    },
    videoWrapper: {
      width: '100%',
      maxWidth: 1000,
    },
  }),
);

const VideoBLock = () => {
  const classes = useStyles();

  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => (
        <div className={classes.videoContainer}>
          <div className={classes.buttonWrapper}>
            <Button {...bindTrigger(popupState)} className={classes.button}>
              <PlayBtn />
            </Button>
          </div>
          <Popover {...bindPopover(popupState)} anchorReference="none">
            <Box className={classes.paddingVideo}>
              <div className={classes.videoWrapper}>
                <video autoPlay controls width={'100%'} controlsList="nodownload">
                  <source src={gpmVideo} type="video/mp4" media="all and (max-width: 480px)" />
                  <source src={gpmVideo} type="video/mp4" />
                </video>
              </div>
            </Box>
          </Popover>
        </div>
      )}
    </PopupState>
  );
};

export default VideoBLock;
